export default __webpack_public_path__ + "static/visibility_toggle.81443a770755a5573db53cbb7e7688a2.svg";